import React from "react";

export const UploadProducerHelpContent = (
    <div className="text-justify">
        <ul style={{ paddingLeft: "15px" }}>
            <li>
                <p>Before Importing your Customers, Set the Default Values you want for all your imported customers, by clicking the Default Values link
                     <ul>
                        <li>You will be able to customize each Customer once they are imported</li>
                    </ul>
                </p>
            </li>
            <li>
                <p>Download the Blank Template
                 <ul>
                        <li>Your Bulk Upload must contain each of these columns in this exact order, even if you don’t use some of the fields</li>
                    </ul>
                </p>
            </li>
            <li>
                <p>First Name, Last Name and Phone Number fields, cannot be blank</p>
            </li>
            <li>
                <p>File must be in a csv format</p>
            </li>
            <li>
                <p>Upload your file</p>
            </li>
            <li>
                <p>If you have any issues, click the ? icon in the top right corner of your screen for  Customer Service</p>
            </li>
        </ul>
    </div>
);
